import { Tooltip } from "@mui/material";
import type React from "react";
import { useSelector } from "react-redux";
import { CommonButton } from "~/components/ui/commonButton";
import AddWhiteIcon from "~/images/add_white_icon.svg?react";
import type { RootState } from "~/store";
import { getRoleDisplayText } from "~/utils/roleUtils";

interface SectionHeaderProps {
  title: string;
  buttonLabel: string;
  onButtonClick: () => void;
  buttonStyle?: string;
  totalProjects?: number;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  buttonLabel,
  onButtonClick,
  totalProjects = 0,
}) => {
  const { organization, currentUser } = useSelector((state: RootState) => state.auth);
  const maxProjects = organization?.plan?.limits?.maxProjects || 0;
  const remainingProjects = maxProjects - totalProjects;

  const isGuestMember = currentUser?.role === "guest" || currentUser?.role === "member";

  const roleDisplayName = getRoleDisplayText(currentUser?.role || "");
  const tooltipMessage = `プロジェクトの作成権限がありません。組織内でのあなたの権限は${roleDisplayName}です。`;

  return (
    <div className="flex justify-between items-center w-full font-sans">
      <h1 className="text-2xl font-medium">{title}</h1>
      <div className="flex-end flex gap-[4px] flex-col">
        <Tooltip title={tooltipMessage} {...(!isGuestMember && { open: false })} arrow>
          <div>
            <CommonButton
              data-testid="create-project-button"
              onClick={onButtonClick}
              className="w-[142px]"
              icon={<AddWhiteIcon />}
              disabled={totalProjects >= maxProjects || isGuestMember}
            >
              {buttonLabel}
            </CommonButton>
          </div>
        </Tooltip>
        <span className="text-[11px] text-gray">
          残りプロジェクト: {remainingProjects}/{maxProjects}
        </span>
      </div>
    </div>
  );
};

export default SectionHeader;
